module.exports = __webpack_public_path__ + "img/zhengce.0c327ca5.png";